<template>
  <ul class="menu">
    <li class="offrebusiness"><a href="#">Offre Business</a></li>
    <li><a href="#">Avis client</a></li>
    <li><a href="#">Blog</a></li>
    <li><a href="#">Nos extras</a></li>
    <li>
      <a href="#">Nos suites</a>
      <div id="sub-menu">
        <div class="sub-menu city">
                <span id="lyon">
                  Lyon
                  <ul class="lyon">
                    <li><a href="#">Les Suites Parsemées - Autour de la place Bellecour</a></li>
                    <li><a href="#">Les Suites Hôtel Particulier Gailleton - Quartier Ainay 69002</a></li>
                    <li><a href="#">Les Suites Tour Rose - 22 rue du Boeuf, Vieux Lyon</a></li>
                  </ul>
                </span>

          <span id="marseille">
                  Marseille
                  <ul class="marseille">
                    <li><a href="#">Les Suites Panier - Quartier du Panier</a></li>
                    <li><a href="#">Les Suites des Auffes - Vallon des Auffes, 13007</a></li>
                    <li><a href="#">Les Suites Vieux Port - Autour du Vieux Port</a></li>
                  </ul>
                </span>
          <span id="paris">
                  Paris
                  <ul class="paris">
                    <li><a href="#">Les Suites du Marais - Quartier du Marais 75003</a></li>
                    <li><a href="#">Les Suites Canal Saint Martin - Autour du Canal</a></li>
                    <li><a href="#">Les Suites Artistes - Montmatre, 75008</a></li>
                  </ul>
                </span>
        </div>
      </div>
    </li>
    <li>
      <a href="#">Notre concept</a>
      <div id="sub-menu">
        <div class="sub-menu">
          <a class="concept" href="#">Suites & Merveilles</a>
          <a class="concept" href="#">L'équipe, les merveilleux</a>
          <a class="concept" href="#">L'espace Presse</a>
        </div>
      </div>
    </li>
    <li><a href="home.html" class="current">Accueil</a></li>
  </ul>
</template>

<script>
export default {
  name: 'router',
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/topbar/router.vue